import '@ssml-editor/vue';

const newLinePlugin = (editor) => {
  const { insertText } = editor;
  const newEditor = editor;
  const insertNewLine = () => {
    insertText("\n");
  };
  editor.once(
    "created",
    (_eventName, _editor, htmlElement) => {
      htmlElement?.addEventListener("keydown", (event) => {
        const isShift = event.shiftKey;
        if (event.key === "Enter") {
          event.preventDefault();
          if (isShift) {
            insertNewLine();
          } else {
            newEditor.insertBreak();
          }
        }
      });
    }
  );
  return newEditor;
};

export { newLinePlugin };
//# sourceMappingURL=new-line-plugin.js.map
